export const DEFAULT_ITEM_NAME = 'item';
